<template>
    <div class="container">
      <div class="top">
          <div class="welcome">
            <br />
            <span class="welcome-message">BIENVENUE | WILLKOMMEN | WELKOM | WELCOME | BIENVENIDO</span>
            <img class="logo" src="../assets/images/logo.png">

          <div class="content">
            <div id="element" class="lang-content" >
                  <p>Sélectionnez votre pays | Wähle dein Land | Kies je land | Select your country | Selecciona tu pais</p>

                <div class="choose-lang">
                  <div class="no-cursor">
                    <a href="./rules-pro/FR_fr-Rules-pro.pdf"  target="_blank"><img src="../assets/images/france.png"></a>
                    <a href="./rules-pro/FR_fr-Rules-pro.pdf" target="_blank">&nbsp;France</a>
                  </div>
                  <div>
                    <img style="-webkit-filter: grayscale(100%); filter: grayscale(100%);" src="../assets/images/belgium.png">
                    <span>België/&nbsp;Belgique</span>
                  </div>
                  
                  <div class="no-cursor">
                    <img style="-webkit-filter: grayscale(100%); filter: grayscale(100%);" src="../assets/images/netherlands.png">
                    <span>&nbsp;Nederland</span>
                  </div>
                  <div>
                    <img style="-webkit-filter: grayscale(100%); filter: grayscale(100%);" src="../assets/images/luxembourg.png">
                    <span>Lëtzebuerg&nbsp;/Luxembourg</span>
                  </div>
                  <div class="no-cursor">
                    <img style="-webkit-filter: grayscale(100%); filter: grayscale(100%);" src="../assets/images/spain2.png">
                    <span>&nbsp;ESPAÑA / Català</span>
                  </div>

                  <div class="no-cursor">
                    <img style="-webkit-filter: grayscale(100%); filter: grayscale(100%);" src="../assets/images/germany.png">
                    <span>&nbsp;Deutsch</span>
                  </div>
                  <div class="no-cursor">
                    <img style="-webkit-filter: grayscale(100%); filter: grayscale(100%);" src="../assets/images/united-kingdom.png">
                    <span>&nbsp;UNITED KINGDOM</span>
                  </div>
                  
                </div>
            
          </div>
          
          </div>
          </div>

      </div>
  <br />&nbsp;<br />
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  name: 'home',
    data: function() {
      return {
        userlang : navigator.language || navigator.userLanguage
      }
    },
    components: {
    },
    methods : {
    }
}
</script>